import React, {useEffect, useRef, useState} from 'react';
import ZoomableImage from './ZoomableImage';

interface ZoomablePhotoProps {
  src: string;
  alt: string;
  isExpanded: boolean;
  onToggleExpand: () => void;
  className?: string;
}

const ZoomablePhoto: React.FC<ZoomablePhotoProps> = ({src, alt, isExpanded, onToggleExpand, className}) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const imgRef = useRef<HTMLImageElement>(null);
  const isPlaceholder = src.includes('/images/placeholder.jpg');

  useEffect(() => {
    setImageLoaded(false);

    const img = imgRef.current;
    if (img && img.complete && img.naturalHeight !== 0) {
      setImageLoaded(true);
    }
  }, [src]);

  const handleImageLoad = () => {
    setImageLoaded(true);
  };

  if (isPlaceholder) {
    return (
      <img
        className={className}
        src={src}
        alt={alt}
      />
    );
  }

  return (
    <ZoomableImage
      isExpanded={isExpanded}
      onToggleExpand={onToggleExpand}
      contentLoaded={imageLoaded}
      resetKey={src}
    >
      <img
        ref={imgRef}
        className={className}
        src={src}
        alt={alt}
        onLoad={handleImageLoad}
      />
    </ZoomableImage>
  );
};

export default ZoomablePhoto;

